import { ExportCostApproachRollupRow } from '../ExportCostApproachRollupRow.tsx';

type Props = {
  data: {
    label: string;
    value: string | null;
  };
  bold?: boolean;
};

export const ManufacturedCostApproachTableRow = ({ data, bold }: Props) => (
  <ExportCostApproachRollupRow
    label={data.label}
    value={data.value ?? ''}
    isBold={bold ?? false}
    showEquals={false}
  />
);
